import Vue from 'vue'

// Shared bar-right responsive state. Right.vue measures overflow and
// flips these flags one at a time (Sort first, then Layout/views, then
// Text/search) — each consumer reads its own flag and switches to a
// compact rendering. Module-level singleton because Vue's slot scope
// doesn't carry provide/inject down through default slots.
//
// Order (most-collapsible first):
//   sort   — sort label is the longest, easiest to drop
//   layout — view name is medium-length
//   text   — search box is the most useful when visible, drop last
export default Vue.observable({
	sort: false,
	layout: false,
	text: false
})
